import { render, staticRenderFns } from "./shopDecoration.vue?vue&type=template&id=51b108e0&scoped=true"
import script from "./shopDecoration.vue?vue&type=script&lang=js"
export * from "./shopDecoration.vue?vue&type=script&lang=js"
import style0 from "./shopDecoration.vue?vue&type=style&index=0&id=51b108e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b108e0",
  null
  
)

export default component.exports